import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CartaDePorteVetada {
  static getCartasDePorte () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_carta_de_porte_automotor_presunta_vetada`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  static getTotalVetadasPorCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_carta_de_porte_automotor_vetada_total')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }
}

export default CartaDePorteVetada
